export default __webpack_public_path__ + "static/media/battlefield.fac619ac.png";